import React from "react";
import { motion, useCycle } from "framer-motion";

const PlayCatch = () => {
  const [x, cycleX] = useCycle(0, Math.random() * 300, 0, Math.random() * -300);

  return (
    <div>
      <h4>Play Catch</h4>
      <motion.div
        className="box"
        style={{ backgroundColor: "#0089BA" }}
        animate={{ x: x }}
        onTap={() => cycleX()}
      ></motion.div>
    </div>
  );
};

export default PlayCatch;
